import * as React from 'react';
import { observable } from "mobx";
import { observer } from "mobx-react";
import { Tabs, Button, Dropdown, Menu } from 'antd';

import { TextView } from '../text.view';
import { RichTextView } from 'src/core/ui/richtextview/text.view.rich';
import { ZuluIcon } from 'src/app/shared/icon';

const TabPane = Tabs.TabPane;

interface TabLanguageViewProps {
	model: Model;
	dynamicProperties: TabLanguageModel[];
	mode: ControlMode;
	languageQuery: () => Promise<QueryResult<LanguageSummary>>;
	defaultLanguage: () => Promise<AppConfiguration>;
	isRichTextBox: boolean | boolean[];
	onChanged?: (newValue: any) => void;
}

interface State {
	selectedKey?: string;
}

@observer
export class TabLanguageView extends React.Component<TabLanguageViewProps, State> {
	public state: State = {}

	private noflag: string = 'iVBORw0KGgoAAAANSUhEUgAAACAAAAAVCAYAAAAnzezqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsQAAA7EAZUrDhsAAAAGYktHRAD/AP8A/6C9p5MAAAHZSURBVEhLxZW7jsJADEU9QTwaGhqE+ADEo0dIUPLVNPwDCAQtIOh5v5czi0PE7mYmxYorWTOx79g3licxvV7vLh9E8Fw/Bm8B9/vdmgu+PIWXgNvtZtfL5RKbnBgcoGdccArQN+p2u9JsNmW/3/8qAh8xOHD1nAuBEv+y8/ksrVbLkguFgrTb7VBE1PARgwM4w9l33rsFtCrOgiCQfr8v2+3WJqZAp9OR3W4n1+vVGnt8WhwuZzj7W86omfF47OwTSo/Ho9RqNclkMtbH82QysftKpSLZbNbuT6eTjEYj+2yMsb44mMFg4D2ytBQRWmy9Xts1n8/bFVEUT6fT9tkHZjgcegugE4ioVquSy+We3m8cDgd5dNMW93lzRaIPEYkp8BD99LyAL2lxkEiAdqDRaDw9L+DTqU8C5zWMms6Atp8Z0DnAR0xF+JqXAK4Liev1ejiAm81GptOpNfaAGJwkIsx8Pnf2DAHlctnea8DArVarcNopWCqVQnHwF4tFyI+DswN824vF4o/iqVQq5LBfLpc2BuByRv8dceaUSDIKgmjx6LSzx0dMRbD36YCZzWZeX0JAa0n611WDpxzgcyXdEh/QRHHFAbEkxYGXAEBCn6S+PIW3gP+ByBfxJS5nmEXtPwAAAABJRU5ErkJggg==';

	@observable
	private languages: LanguageSummary[];

	private emptyLanguages: any[];

	@observable
	private defaultLanguage: string;

	public componentDidMount() {
		this.props.languageQuery().then(res => { this.languages = res.items; });
		this.props.defaultLanguage().then(res => {
			this.defaultLanguage = res.defaultLanguage;
			this.setState({ selectedKey: this.defaultLanguage });
		});
	}

	public render() {
		const components = [];
		this.emptyLanguages = [];
		if (this.languages != null && this.languages.length == 1) {
			return (<div>
				{this.createSimpleEditor(this.languages[0].languageCode)}
			</div>);
		} else {
			if (this.props.dynamicProperties != null && this.props.dynamicProperties.length > 0 && this.languages != null) {
				const displayNames = this.props.dynamicProperties[0];
				for (let lang of this.languages) {
					if (displayNames.dynamicProperties) {
						let language: string = displayNames.dynamicProperties[lang.languageCode];
						if (language != null) {
							components.push(
								<TabPane key={lang.languageCode} tab={this.renderTabLink(lang.languageCode)}>
									{this.createSimpleEditor(lang.languageCode)}
								</TabPane>);

						} else {
							let array = lang.flag ? btoa(String.fromCharCode.apply(null, new Uint8Array(lang.flag.buffer))) : this.noflag;
							this.emptyLanguages.push({
								key: lang.languageCode,
								name: lang.displayName,
								style: {
									background: 'url(data:image/png;base64,' + array + ') no-repeat right center'
								}
							});
						}
					}
				}
			}

			let array: any[] = [];
			for (var i = 0; i < this.emptyLanguages.length; i++) {
				array.push(<Menu.Item key={this.emptyLanguages[i].key} ><span style={this.emptyLanguages[i].style} ><label>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</label></span></Menu.Item>);
			}

			const menu = (
				<Menu onClick={this.addLanguage}>
					{array}
				</Menu>
			);
			const operations = <div>
				{(this.props.mode == "edit") && < Dropdown overlay={menu} trigger={['click']}><Button icon="plus"></Button></Dropdown>}
			</div>;
			return components.length > 0
				? (
					<Tabs
						hideAdd
						activeKey={this.state.selectedKey}
						onTabClick={this.linkClick}
						tabBarExtraContent={operations} >
						{
							components
						}

					</Tabs>
				)
				: null;
		}

	}

	private isRichTextBox(index: number): boolean {
		if (Array.isArray(this.props.isRichTextBox)) {
			return this.props.isRichTextBox[index];
		}
		return this.props.isRichTextBox;
	}

	private createSimpleEditor(languageCode: string) {
		const components = [];
		let index = 0;
		for (let displayName of this.props.dynamicProperties) {
			let language: string = displayName.dynamicProperties[languageCode];
			if (language != null) {
				let displayNames = displayName.dynamicProperties;
				if (this.isRichTextBox(index)) {
					components.push(
						<RichTextView
							key={displayName.title.concat(languageCode)}
							mode={this.props.mode}
							label={displayName.title}
							value={language}
							onChanged={this.changeLanguaje(displayNames, languageCode)}
							required={displayName.required}
						/>
					);
				} else {
					components.push(
						<TextView
							key={displayName.title.concat(languageCode)}
							mode={this.props.mode}
							label={displayName.title}
							value={language}
							onChanged={this.changeLanguaje(displayNames, languageCode)}
							rows={displayName.rows}
							required={displayName.required}
						/>
					);
				}
			}

			index += 1;
		}

		return components;
	}
	
	private linkClick = (item: string) => {
		this.setState({ selectedKey: item });
	}
	
	private changeLanguaje = (obj: Object, prop: string) => (value: any) => {
		obj[prop] = value;
		this.languages = this.languages.slice();
		if (this.props.onChanged) {
			this.props.onChanged(value);
		}
		this.setState({
			selectedKey: prop,
		});
	}

	private renderTabLink(link: string): JSX.Element {
		const language = this.languages.find(e => e.languageCode == link);
		const flag = btoa(String.fromCharCode.apply(null, language.flag));
		return (
			<span>
				<img src={'data:image/png;base64,' + flag} style={{ marginRight: '1px' }} />
				{this.props.mode == 'edit' && this.defaultLanguage != language.languageCode && <ZuluIcon type='close' onClick={this.removeLanguage(language)} style={{ marginLeft: '1px', zIndex: 1000 }} />}
			</span>
		);
	}

	private removeLanguage = (language: LanguageSummary) => () => {
		for (const dp of this.props.dynamicProperties) {
			dp.dynamicProperties[language.languageCode] = undefined;
			delete dp.dynamicProperties[language.languageCode];
			this.languages = this.languages.slice();
		}
		this.setState({ selectedKey: this.defaultLanguage });
	}

	private addLanguage = (item: any) => {
		for (const dp of this.props.dynamicProperties) {
			dp.dynamicProperties[item.key] = '';
			this.languages = this.languages.slice();
		}
		this.setState({ selectedKey: this.defaultLanguage });
	}
}



// WEBPACK FOOTER //
// ./src/core/ui/language/tab-language.view.tsx